<template>
	<v-card
		class="system-template-card"
		:class="{ 'selected': selected }"
		elevation="2"
		hover
		role="button"
		tabindex="0"
		:aria-label="`Select ${template.name} template. ${template.description}`"
		:aria-pressed="selected"
		@click="$emit('select')"
		@keydown="handleKeydown"
	>
		<v-card-text class="pa-4">
			<div class="template-card-content">
				<div class="template-icon-section">
					<v-avatar
						size="56"
						:color="template.color || 'primary'"
						class="white--text"
					>
						<font-awesome-icon
							v-if="template.icon && template.icon.startsWith('fa')"
							:icon="getFontAwesomeIcon(template.icon)"
							size="2x"
							:style="{ color: template.iconColor || 'white' }"
						/>
						<v-icon
							v-else-if="template.icon"
							size="32"
							:color="template.iconColor || 'white'"
						>
							{{ template.icon }}
						</v-icon>
						<span
							v-else
							class="font-weight-bold text-h6"
						>
							{{ template.name.charAt(0).toUpperCase() }}
						</span>
					</v-avatar>
				</div>
				<div class="template-content-section">
					<h3 class="template-title text-h6 font-weight-medium mb-1">
						{{ template.name }}
					</h3>
					<p class="template-description text-body-2 text--secondary mb-0">
						{{ template.description }}
					</p>
				</div>
				<div
					v-if="selected"
					class="selection-indicator"
				>
					<v-icon
						color="primary"
						size="24"
					>
						mdi-check-circle
					</v-icon>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { getFontAwesomeIcon } from '../../../../../shared/utils/get-font-awesome-icon.js'
export default {
	name: 'system-template-card',
	props: {
		template: {
			type: Object,
			required: true
		},
		selected: {
			type: Boolean,
			default: false
		}
	},
	setup () {
		return {
			getFontAwesomeIcon
		}
	},
	methods: {
		handleKeydown (event) {
			// Handle keyboard activation (Enter and Space keys)
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault()
				this.$emit('select')
			}
		}
	}
}
</script>

<style scoped>
.system-template-card {
	cursor: pointer;
	transition: all 0.2s ease;
	border: 2px solid transparent;
	background-color: var(--bg-secondary, var(--global-main-background-color));
	max-width: 400px;
	height: auto;
	position: relative;
}

.system-template-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px var(--bg-overlay, rgba(0, 0, 0, 0.25)) !important;
}

.system-template-card.selected {
	border-color: var(--v-primary-base);
	background-color: rgba(var(--v-primary-base), 0.05);
}

.system-template-card:focus {
	outline: 2px solid var(--v-primary-base, var(--global-color-blue-darken-2));
	outline-offset: 2px;
}

.system-template-card:focus:not(:focus-visible) {
	outline: none;
}

.template-card-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	position: relative;
	min-height: 140px;
}

.template-icon-section {
	margin-bottom: 16px;
}

.template-content-section {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.template-title {
	color: var(--text-primary, rgba(0, 0, 0, 0.87));
	line-height: 1.3;
	text-align: center;
}

.template-description {
	color: var(--text-secondary, rgba(0, 0, 0, 0.6));
	line-height: 1.4;
	text-align: center;
}

.selection-indicator {
	position: absolute;
	top: 8px;
	right: 8px;
	flex-shrink: 0;
}

/* Responsive adjustments */
@media (max-width: 600px) {
	.template-icon {
		margin-right: 12px;
	}

	.template-icon .v-avatar {
		width: 40px !important;
		height: 40px !important;
	}

	.template-title {
		font-size: 1.1rem;
	}

	.template-description {
		font-size: 0.875rem;
	}
}
</style>
